import React from 'react';
import { Button, Drawer, FloatingLabelInput } from '../../../../../../../ui';

interface ICreateNewQuestion {
  isOpen: boolean;
  onCloseDrawer: () => void; // Fixed function type
}

export const CreateNewQuestion = ({
  isOpen,
  onCloseDrawer,
}: ICreateNewQuestion) => {
  return (
    <Drawer
        isOpen={isOpen}
        onClose={onCloseDrawer}
        footerContent={
          <div className='flex justify-end gap-5 w-full'>
            <Button label='Cancel' onClick={onCloseDrawer} variant='secondary' />{ ' ' }
            <Button label='Create' onClick={() => {}} variant='primary' />
          </div>
        }
        title='Create New Question'
        width='w-full md:w-1/3'
    >
      <div className='gap-5 p-5'>
        <FloatingLabelInput
            label='Job Title'
            type='text'
            placeholder={'Job title'}
            required
            value={''}
            onChange={() => {}}
        />
        <div className='py-5'>
          <FloatingLabelInput
              label='Answer'
              type='text'
              placeholder={'Answer'}
              required
              value={''}
              onChange={() => {}}
          />
        </div>
        <div className='pb-5'>
          <Button label='Upload Media' onClick={() => {}} variant='secondary' />
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <FloatingLabelInput
              label='Skill'
              type='text'
              placeholder='Skill'
              required
              value=''
              onChange={() => {}}
          />
          <FloatingLabelInput
              label='Sub-skill-1'
              type='text'
              placeholder='Sub-skill-1'
              required
              value=''
              onChange={() => {}}
          />
          <FloatingLabelInput
              label='Level'
              type='text'
              placeholder='Level'
              required
              value=''
              onChange={() => {}}
          />
          <FloatingLabelInput
              label='Question Type'
              type='text'
              placeholder='Question Type'
              required
              value=''
              onChange={() => {}}
          />
          <FloatingLabelInput
              label='Timer (Seconds)'
              type='text'
              placeholder='Timer (Seconds)'
              required
              value=''
              onChange={() => {}}
          />
          <FloatingLabelInput
              label='Point For Question'
              type='text'
              placeholder='Point For Question'
              required
              value=''
              onChange={() => {}}
          />
        </div>
      </div>
    </Drawer>
  );
};
